import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";
import ownerStatement1 from "../../../../../../../assets/images/owner-statement.jpeg";

import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function MakeReadyFund({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="MAKE READY FUNDS-IMPORTANT" />
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <p className="blue-info-text red-info-heading">
                  When the estimate is sent by Stingray or any other vendor
                  ensure that there are sufficient funds in the property owners
                  account to pay for the repairs.
                </p>
              </Col>
              <Col span={24}>
                <p className="blue-info-text onclick-text">
                  You can verify funds here - owner report enhanced
                </p>
              </Col>
              <Col span={24}>
                <p className="blue-info-text">
                  make sure and look at the funds in the ending cash balance of
                  the consolidates summary at the top of the report as seen in
                  image below.
                </p>
              </Col>
              <Col span={24}>
                <img
                  className="owner-statement-img"
                  src={ownerStatement1}
                  alt=""
                />
              </Col>
              <Col span={24}>
                <p className="blue-info-text">
                  If there are is not enough funds to pay for the repair send
                  the message below to the owner and bcc stingray homes on the
                  message sent from appfolio.
                </p>
              </Col>
              <Col span={24} className="blue-info-text">
                <strong>Owner email</strong>
                <p>Make sure to attach the report you have downloaded</p>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default MakeReadyFund;
